import { render, staticRenderFns } from "./LinkGroup.vue?vue&type=template&id=4f6ab775&scoped=true"
import script from "./LinkGroup.vue?vue&type=script&lang=js"
export * from "./LinkGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6ab775",
  null
  
)

export default component.exports